import React, { FC } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { useTranslation } from 'react-i18next';

import { VideoPlayer } from '@clover-growth/video-player';

import styles from './Lightbox.module.scss';
import { ReferencedEntry } from 'contentful';
import { Topic } from 'api/contentful/contentTypes.cloverdotcom';
import { getField } from 'utils/EntryUtil';
import cx from 'classnames';
import { onRequestClose } from 'components/NestedRoute/NestedModals';
import closeIcon from 'images/icons/video-close.svg';
import { Image } from 'components/Image/Image';
import { useLightboxVideoEffect } from 'hooks/useLightboxVideoEffect';

interface ILightboxProps extends RouteComponentProps {
  entry?: ReferencedEntry<Topic>;
  videoPlayerClassName?: string;
  modalBaseUrl?: string;
}

const Lightbox: FC<ILightboxProps> = ({ entry, videoPlayerClassName, history, match, modalBaseUrl }) => {
  const { t } = useTranslation();

  const videoPlayerProps = getField(entry, 'videoPlayer')?.fields;
  const isNative = videoPlayerProps?.playerType === 'native';
  const posterUrl = videoPlayerProps?.thumbnail?.fields.file.url;

  // Temporary! Manual overrides for accessibility. To be removed during CGH-9835
  useLightboxVideoEffect(isNative, posterUrl);

  return (
    <div className={styles.wrapper}>
      <button
        onClick={() => onRequestClose(history, match, modalBaseUrl)}
        title="close"
        aria-label={t('close')}
        className={cx(styles.closeButton, {
          [styles.nativeCloseButton]: isNative,
          [styles.nonNativeCloseButton]: !isNative,
        })}
      >
        <Image src={closeIcon} className={styles.closeIcon} />
      </button>
      <VideoPlayer
        {...videoPlayerProps}
        className={videoPlayerClassName}
        videoUrl={videoPlayerProps?.media?.fields.file.url ?? videoPlayerProps?.videoUrl ?? ''}
        posterUrl={posterUrl}
        label="Video Player"
        inlineControls="over-player"
        theme="white"
      />
    </div>
  );
};

const WithRouter = withRouter(Lightbox);
export { WithRouter as Lightbox };
